/**
 * UI color utilities for tags and badges
 */

function stringToBondThemeColor(str, _baseHue) {
    const baseHue = _baseHue || 220;

    let hash = 0;
    for (let i = 0; i < str.length; i++) {
        hash = str.charCodeAt(i) + ((hash << 5) - hash);
    }

    // Force the hash into positive range
    hash = Math.abs(hash);

    // Base HSL values around the Bond theme (deep blue and grayish blue)
    const hueVariation = (hash % 30) - 15; // Small variation (-10 to +10)
    const hue = (baseHue + hueVariation + 360) % 360;

    const baseSaturation = 20; // Mild saturation (not too colorful)
    const saturationVariation = (hash % 40); // up to +20%
    const saturation = Math.min(baseSaturation + saturationVariation, 50);

    const baseLightness = 20; // Middle dark
    const lightnessVariation = (hash % 30); // up to +30%
    const lightness = Math.min(baseLightness + lightnessVariation, 70);

    return `hsl(${hue}, ${saturation}%, ${lightness}%)`;
}

const tagColors = {
    "location": 220,
    "bond": 20,
    "template": 100
}

function tagColor(tag, value) {
    let baseHue = tagColors[tag];
    tag = tag ? tag.toString() : "default";
    value = value ? value.toString() : tag;
    try {
        if (baseHue === undefined) {
            let hash = 0;
            for (let i = 0; i < tag.length; i++) {
                hash = tag.charCodeAt(i) + ((hash << 5) - hash);
            }
            baseHue = (Math.abs(hash) % 220) + 1;
        }
    } catch (e) {
        console.log(e)
    }
    return {cssText: `background-color: ${stringToBondThemeColor(value, baseHue)} !important`}
}

function deviceTypeBadgeColor(deviceType) {
    if (!deviceType) return 'success';

    // Use the existing stringToBondThemeColor to generate dynamic colors
    const baseHue = 180; // Base hue for device types
    return {cssText: `background-color: ${stringToBondThemeColor(deviceType, baseHue)} !important`};
}

export function getConnectivityColor(isConnected) {
    return isConnected ? '#4caf7d' : '#e57373';
}

// Bond color cache for consistent colors across the app
const bondColorCache = {};

/**
 * Generate consistent blue-toned colors for bond IDs
 * All bonds get unique shades of blue with enough variation to distinguish them
 */
export function getBondColor(bondId) {
    if (!bondId) return '#6c757d'; // Default gray for missing bond ID

    if (!bondColorCache[bondId]) {
        // Generate hash from bond ID
        let hash = 0;
        const bondIdStr = bondId.toString();
        for (let i = 0; i < bondIdStr.length; i++) {
            hash = bondIdStr.charCodeAt(i) + ((hash << 5) - hash);
        }
        hash = Math.abs(hash);

        // Keep hue in blue range with variation (190-240 degrees for blue spectrum)
        const hue = 190 + (hash % 50); // Blue tones
        // Vary saturation and lightness for distinction
        const saturation = 50 + (hash % 35); // 50-85%
        const lightness = 30 + ((hash >> 8) % 18); // 30-48% (darker range)

        bondColorCache[bondId] = `hsl(${hue}, ${saturation}%, ${lightness}%)`;
    }
    return bondColorCache[bondId];
}

export { tagColor, deviceTypeBadgeColor, stringToBondThemeColor };
